import React, { useState } from 'react';
import H1 from '../Images/Hma.jpeg'
import H2 from '../Images/H2.jpeg'
import axios from 'axios';
import { FaUser, FaMobileAlt, FaEnvelope, FaBuilding, FaRegCreditCard, FaMapMarkerAlt, FaQrcode, FaFile } from 'react-icons/fa';

const Registration = () => {
    const [formData, setFormData] = useState({
        image: '',
        name: '',
        mobile: '',
        email: '',
        address: '',
        organisation: '',
        category: '',
        paymentAmount: 0,
        utr_no: '',
    });

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
    
        if (type === 'file') {
            setFormData(prevData => ({
                ...prevData,
                [name]: files[0], 
            }));
        } else {
            setFormData(prevData => ({
                ...prevData,
                [name]: value,
            }));
        }
        if (name === 'category') {
            calculatePayment(value);
        }
    };
    

    const calculatePayment = (category) => {
        let baseAmount = 0;

        switch (category) {
            case 'HMA MEMBER':
                baseAmount = 1180;
                break;
            case 'FACULTY':
                baseAmount = 1770;
                break;
            case 'STUDENT':
                baseAmount = 590;
                break;
            case 'NON HMA MEMBER':
                baseAmount = 2360;
                break;
            default:
                baseAmount = 0;
        }

        const totalAmount = Math.round(baseAmount);
        setFormData((prevData) => ({
            ...prevData,
            paymentAmount: totalAmount,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const formDataToSend = new FormData();
        Object.keys(formData).forEach(key => {
            if (key === 'image' && formData[key]) {
                formDataToSend.append(key, formData[key]);
            } else {
                formDataToSend.append(key, formData[key]);
            }
        });
    
        try {
            const response = await axios.post('https://api.hmahyd.org/pages/api/register', formDataToSend);
            const result = response.data;
            if (response.status === 200) {
                const { name, mobile, paymentAmount, category } = formData;
                const subject = `Registration for ${category}`;
                const bankRegistration = `Bank Registration: ${formData.utr_no}`;
                alert(
                    `Registration successful!\n\n` +
                    `Subject: ${subject}\n` +
                    `Name: ${name}\n` +
                    `Mobile: ${mobile}\n` +
                    `Payment: ₹${paymentAmount}\n` +
                    `${bankRegistration}\n\n` +
                    `Thank you! We have received your application subject to payment verification with the bank. ` +
                    `Please show your payment receipt at the venue on 8th Feb 2025.`
                );
                setFormData({ image: '', name: '', mobile: '', email: '', address: '', organisation: '', category: '', paymentAmount: 0, utr_no: '' });
            } else {
                alert(`Error: ${result.message}`);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error with the registration.');
        }
    };
      
    return (
        <div className="mt-1">
            <img src={H1} alt="item" style={{ height: '250px', width: '100%' }} />
            <div className='container mt-2'>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-6 mb-3">
                            <label htmlFor="name" className="form-label"><FaUser className="me-2" /> Name</label>
                            <input type="text" style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="name" name="name" value={formData.name} onChange={handleChange} required />
                        </div>
                        <div className="col-6 mb-3">
                            <label htmlFor="mobile" className="form-label"><FaMobileAlt className="me-2" /> Mobile No</label>
                            <input type="text" style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} maxLength={10} required />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6 mb-3">
                            <label htmlFor="email" className="form-label"><FaEnvelope className="me-2" /> Email ID</label>
                            <input type="email" style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="email" name="email" value={formData.email} onChange={handleChange} required />
                        </div>
                        <div className="col-6 mb-3">
                            <label htmlFor="organisation" className="form-label"><FaBuilding className="me-2" /> Name of Organisation/Institution</label>
                            <input type="text" style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="organisation" name="organisation" value={formData.organisation} onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6 mb-3">
                            <label htmlFor="category" className="form-label"><FaRegCreditCard className="me-2" /> Category</label>
                            <select style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="category" name="category" value={formData.category} onChange={handleChange} required>
                                <option value="">Select</option>
                                <option value="HMA MEMBER">HMA MEMBER(1180)</option>
                                <option value="FACULTY">ACADEMICIANS FACULTY(1770)</option>
                                <option value="STUDENT">STUDENT(590)</option>
                                <option value="NON HMA MEMBER">DELEGATE (or) NON HMA MEMBER(2360)</option>
                            </select>
                        </div>

                        <div className="col-6 mb-3">
                            <label htmlFor="paymentAmount" className="form-label"><FaRegCreditCard className="me-2" /> Payment Amount</label>
                            <input type="text" style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="paymentAmount" name="paymentAmount" value={`₹${formData.paymentAmount}`} readOnly />
                        </div>
                    </div>

                    <div className="mb-1">
                        <label htmlFor="address" className="form-label"><FaMapMarkerAlt className="me-2" /> Address</label>
                        <textarea style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="address" name="address" rows="3" value={formData.address} onChange={handleChange} required />
                    </div>

                    <div className="row mb-5">
                        <div className="col-md-6 mb-3">
                            <img src={H2} alt="item" className="img-fluid rounded" />
                        </div>
                        <div className="col-md-6">
                            <div className='mt-5'>
                                <label htmlFor="utr_no" className="form-label"><FaQrcode className="me-2" />Enter UTR No</label>
                                <input type="text" style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="utr_no" name="utr_no" value={formData.utr_no} onChange={handleChange} required maxLength={20} />
                            </div>
                            <div className='mt-5'>
                                <label htmlFor="utr_no" className="form-label"><FaFile className="me-2" />Screenshot Of Payment Proof</label>
                                <input type="file" style={{ border: '1px solid black', padding: '10px', width: '100%' }} id="image" name="image" onChange={handleChange} required />
                            </div>
                        </div>
                        <div className='mt-3'>
                            <button type="submit" style={{ border: '1px solid black', padding: '10px', width: '100%', backgroundColor: 'black', color: 'white' }}>SUBMIT</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Registration;
